import styled from "styled-components";
import classnames from "classnames";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { variantToColour } from "../../helpers/theme";

const ThemedHeader = styled(Dropdown.Header)`
    color: ${props => variantToColour({ theme: props.theme, variant: props.variant ?? '#000' })};
`;

const ThemedItem = styled(Dropdown.Item)`
    color: ${props => variantToColour({ theme: props.theme, variant: props.variant ?? '#000' })};
`;

export const DropdownMenuHeader = ({ children, className, ...rest }) => (
    <ThemedHeader className={classnames('text-ellipsis', className)} {...rest}>
        {children}
    </ThemedHeader>
)

export const DropdownMenuItem = ({ children, icon = null, ...rest }) => {
    return icon
        ? (
            <ThemedItem {...rest}>
                <FontAwesomeIcon icon={icon} size="sm" /> <span className="ms-1">{children}</span>
            </ThemedItem>
        )
        : (
            <ThemedItem {...rest}>
                <span>{children}</span>
            </ThemedItem>
        )
};